import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";
import "./i18n";

// const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
// TagManager.initialize({ gtmId });

const devMode = import.meta.env.VITE_IS_DEBUG;
if (devMode !== "true") {
  Sentry.init({
    dsn: "https://0e95c7f584c40ca2c383d05dcf78e5ab@o4509021017407488.ingest.de.sentry.io/4509021020225616",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/app\.optivise\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else {
  console.debug("Dev mode, no Sentry init...");
}

// Fallback literal: Frontend/.dockerignore excludes **/.env.*, so .env.production never
// reaches the image build and import.meta.env.VITE_* is undefined in the deployed bundle
// (same reason api.js hard-codes the API prefix). Mixpanel web tokens are public.
const trackingKey =
  import.meta.env.VITE_MIXPANEL_TRACKING_KEY || "dcf6a631fb10d614463e406cfac4c2ee";
if (devMode === "true") {
  mixpanel.init(trackingKey, {
    debug: true,
    track_pageview: true,
    ignore_dnt: false,
    persistence: "localStorage",
  });
  console.warn("TRACKING IN DEV MODE!");
} else {
  mixpanel.init(trackingKey, {
    debug: false,
    track_pageview: true,
    ignore_dnt: true,
    persistence: "localStorage",
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
